import iconOrder from 'assets/images/icons/icon-order-32.png';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { emptyFn } from 'utils/common';
import styles from '../index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  isActive: false,
  isAscending: true,
  onClick: emptyFn
};
const propTypes = {
  isActive: PropTypes.bool,
  isAscending: PropTypes.bool,
  onClick: PropTypes.func
};

const OrderBtn = ({ isActive, isAscending, onClick }) => (
  <img
    alt="Column order"
    className={`cursor-pointer ${cx('iconOrder', {
      ascending: isAscending,
      active: isActive
    })}`}
    onClick={() => onClick(isAscending)}
    src={iconOrder}
  />
);

OrderBtn.defaultProps = defaultProps;
OrderBtn.propTypes = propTypes;
export default OrderBtn;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/components/UIs/OrderBtn.jsx